export default function getPrevMerchantsState() {
	return {
		data: {
			merchants: []
		}
	};
}



// WEBPACK FOOTER //
// ./src/Merchants/Reducer/getPrevMerchantsState.js